/** biome-ignore-all lint/style/useNamingConvention: allow snake case */
interface BackendGuestOptions {
  event_option_private_guestlist?: boolean;
  event_option_allow_guest_number?: boolean;
  event_option_max_guest_number?: number;
  event_option_max_guests?: number;
  event_option_allow_kids?: boolean;
  event_option_allow_maybe_rsvps?: boolean;
  event_option_rsvp_by?: Date;
  event_option_strict_rsvp_by?: boolean;
  [key: string]: unknown;
}

interface FrontendGuestOptions {
  hideGuestlist?: boolean;
  allowBringPeople?: boolean;
  limitPerGuest?: number;
  maxGuestList?: number;
  allowKids?: boolean;
  allowMaybeRSVPs?: boolean;
  rsvpDeadline?: Date;
  rsvpDeadlineIsStrict?: boolean;
  showMaxGuest?: boolean;
  [key: string]: unknown;
}

export const GUEST_OPTIONS_FIELD_MAPPING: Record<
  keyof BackendGuestOptions,
  keyof FrontendGuestOptions
> = {
  event_option_private_guestlist: 'hideGuestlist',
  event_option_allow_guest_number: 'allowBringPeople',
  event_option_max_guest_number: 'limitPerGuest',
  event_option_max_guests: 'maxGuestList',
  event_option_allow_kids: 'allowKids',
  event_option_allow_maybe_rsvps: 'allowMaybeRSVPs',
  event_option_rsvp_by: 'rsvpDeadline',
  event_option_strict_rsvp_by: 'rsvpDeadlineIsStrict',
};

export const GUEST_OPTIONS_REVERSE_MAPPING: Record<
  keyof FrontendGuestOptions,
  keyof BackendGuestOptions
> = Object.fromEntries(
  Object.entries(GUEST_OPTIONS_FIELD_MAPPING).map(([backend, frontend]) => [frontend, backend])
) as Record<keyof FrontendGuestOptions, keyof BackendGuestOptions>;

export const mapGuestOptionsToBackend = (
  frontendGuestOptions: FrontendGuestOptions = {}
): BackendGuestOptions => {
  const backendOptions: BackendGuestOptions = {};

  Object.entries(frontendGuestOptions).forEach(([frontendKey, value]) => {
    if (frontendKey === 'showMaxGuest') return;
    const backendKey =
      GUEST_OPTIONS_REVERSE_MAPPING[frontendKey as keyof FrontendGuestOptions] || frontendKey;
    const isDeadlineConfig = frontendKey.includes('rsvpDeadline');
    if (isDeadlineConfig || (value !== undefined && value !== null))
      backendOptions[backendKey] = value;
  });

  return backendOptions;
};

export const mapGuestOptionsFromBackend = (
  backendOptions: BackendGuestOptions = {}
): FrontendGuestOptions => {
  const frontendOptions: FrontendGuestOptions = {};

  Object.entries(backendOptions).forEach(([backendKey, value]) => {
    const frontendKey = GUEST_OPTIONS_FIELD_MAPPING[backendKey as keyof BackendGuestOptions];
    if (frontendKey) frontendOptions[frontendKey] = value;
  });

  // If plus ones are disabled, limit per guest should always be 0 for display consistency
  if (backendOptions.event_option_allow_guest_number === false) {
    frontendOptions.limitPerGuest = 0;
  }

  return frontendOptions;
};
